import { Button, Typography, Grid, Paper, InputLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import SendIcon from '@material-ui/icons/Send';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(3),
   
    borderRadius: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(3),
    borderRadius: theme.spacing(2),
    padding: theme.spacing(1.5, 4),
    fontSize: "1rem",
    textTransform: "none",
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  sendIcon: {
    marginLeft: theme.spacing(1),
  },
  label: {
    fontSize: "0.9rem",
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
}));

export default function DateRange({ handleSendWorkflowDateRange, language="en" }) {
  const classes = useStyles();
  const [isSelected, setIsSelected] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  
  // Calculate min and max dates based on requirements
  const minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 1); // One year ago
  const maxDate = new Date(); // Current date
  
  const handleStartDateChange = (date) => {
    setStartDate(date);
    // Adjust end date if it's outside the one month range
    if (date) {
      const newEndDate = new Date(date);
      newEndDate.setMonth(newEndDate.getMonth() + 1); // Add one month
      newEndDate.setDate(newEndDate.getDate() - 1); // Subtract one day to get the end of the month
      if (newEndDate > maxDate) {
        setEndDate(maxDate);
      } else {
        setEndDate(newEndDate);
      }
    }
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const sendDateRange = () => {
    if (startDate && endDate && startDate <= endDate) {
      setIsSelected(true);
      handleSendWorkflowDateRange({
        startDate: startDate.toLocaleDateString("en-GB").replace(/\//g, ""),
        endDate: endDate.toLocaleDateString("en-GB").replace(/\//g, ""),
      }, language);
    }
  };

  return (
    <Paper elevation={3} className={classes.paper} style={{ border: "8px solid rgba(244, 176, 53, 0.8)" }}>
      <Typography variant="h5" gutterBottom>
        {language === 'en' ? "Enter Your Date Range" :
          language === 'hn' ? "अपनी तारीख सीमा दर्ज करें" :
          language === 'od' ? "ତାରିଖ ଶ୍ରେଣୀ ଦାଖଲ କରନ୍ତୁ" : ""}
      </Typography>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <InputLabel className={classes.label}>Start Date</InputLabel>
            <KeyboardDatePicker
              autoOk
              variant="inline"
              inputVariant="outlined"
              format="dd/MM/yyyy"
              disableFuture
              minDate={minDate}
              maxDate={maxDate}
              value={startDate}
              onChange={handleStartDateChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputLabel className={classes.label}>End Date</InputLabel>
            <KeyboardDatePicker
              autoOk
              variant="inline"
              inputVariant="outlined"
              format="dd/MM/yyyy"
              disableFuture
              minDate={startDate}
              maxDate={maxDate}
              value={endDate}
              onChange={handleEndDateChange}
              fullWidth
            />
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        disabled={isSelected}
        onClick={sendDateRange}
      >
        Send
        <SendIcon className={classes.sendIcon} />
      </Button>
    </Paper>
  );
}




// import { Button, Icon, Typography, Grid } from "@material-ui/core";
// import { makeStyles } from "@material-ui/core/styles";
// import React, { useState } from "react";
// import "date-fns";
// import DateFnsUtils from "@date-io/date-fns";
// import {
//   MuiPickersUtilsProvider,
//   KeyboardDatePicker,
// } from "@material-ui/pickers";

// const useStyles = makeStyles((theme) => ({
//   container: {
//     display: "flex",
//     flexWrap: "wrap",
//   },
//   textField: {
//     marginLeft: theme.spacing(1),
//     marginRight: theme.spacing(1),
//     width: 200,
//   },
//   button: {
//     margin: theme.spacing(1),
//   }
// }));

// export default function DateRange({ handleSendWorkflowDateRange, language }) {
//   const classes = useStyles();
//   const [isSelected, setIsSelected] = useState(false);
//   const [startDate, setStartDate] = useState(new Date());
//   const [endDate, setEndDate] = useState(new Date());

//   const handleStartDateChange = (date) => {
//     console.log("------------",date);
//     setStartDate(date);
//   };

//   const handleEndDateChange = (date) => {
//     console.log("------------",date);
//     setEndDate(date);
//   };

//   return (
//     <div className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70">
//       <Grid item xs>
//         <Typography
//           gutterBottom
//           variant="button"
//           align="center"
//           component="subtitle2"
//           display="block"
//         >
//           {language === 'en' ? (
//             <h5 className="date_of_birth_card_header">
//               Enter Your Date Range
//             </h5>
//           ) : language === 'hn' ? (
//             <h5 className="date_of_birth_card_header">
//               अपनी तारीख सीमा दर्ज करें
//             </h5>
//           ) : language === 'od' ? (
//             <h5 className="date_of_birth_card_header">
//               ତାରିଖ ଶ୍ରେଣୀ ଦାଖଲ କରନ୍ତୁ
//             </h5>
//           ) : null}
//         </Typography>
//       </Grid>
//       <MuiPickersUtilsProvider utils={DateFnsUtils}>
//         <Grid container justifyContent="space-around">
//           <KeyboardDatePicker
//             autoOk
//             variant="inline"
//             inputVariant="outlined"
//             format="dd/MM/yyyy"
//             disableFuture
//             label="Start Date"
//             value={startDate}
//             InputAdornmentProps={{ position: "start" }}
//             onChange={handleStartDateChange}
//           />
//           <KeyboardDatePicker
//             autoOk
//             variant="inline"
//             inputVariant="outlined"
//             format="dd/MM/yyyy"
//             disableFuture
//             label="End Date"
//             value={endDate}
//             InputAdornmentProps={{ position: "start" }}
//             onChange={handleEndDateChange}
//           />
//         </Grid>
//       </MuiPickersUtilsProvider>
//       <Button
//         variant="contained"
//         color="primary"
//         className={classes.button}
//         endIcon={<Icon>send</Icon>}
//         disabled={isSelected}
//         onClick={() => {
//           if (startDate && endDate && startDate <= endDate) {
//             setIsSelected(true);
//             handleSendWorkflowDateRange({
//               startDate: startDate.toLocaleDateString("en-GB").replace(/\//g, ""),
//               endDate: endDate.toLocaleDateString("en-GB").replace(/\//g, ""),
//             }, language);
//           }
//         }}
//       >
//         Send
//       </Button>
//     </div>
//   );
// }
